module.exports = __webpack_public_path__ + "img/logoTRB.24de4b12.png";